import React from 'react';
import { GetStaticProps } from 'next';
import { useRouter } from 'next/router';
import { QueryClient } from '@tanstack/react-query';
import * as yup from 'yup';
import { useTranslation } from 'next-i18next';
import { LoginForm } from '@blueprint/core';
import { sharedPageProps } from '@sje-kraken/utils/props';
import { INTERNAL_PATHS } from '@sje-kraken/utils/urls';

const Login = () => {
  const router = useRouter();
  const { t } = useTranslation('common');
  const validationSchema = yup.object().shape({
    email: yup
      .string()
      .email(t('login-form.email.format-validation'))
      .required(t('login-form.email.required-validation')),
    password: yup
      .string()
      .min(7, t('login-form.password.min-length-validation'))
      .required(t('login-form.password.required-validation')),
  });
  return (
    <>
      <LoginForm
        forgotPasswordUrl={INTERNAL_PATHS.REQUEST_PASSWORD_RESET.createPath(
          { locale: router.locale }
        )}
        createPasswordUrl={INTERNAL_PATHS.REQUEST_PASSWORD_RESET.createPath(
          { locale: router.locale, create: true }
        )}
        validationSchema={validationSchema}
      />
    </>
  );
};

export const getStaticProps: GetStaticProps = async (context) => {
  const queryClient = new QueryClient();

  return {
    props: await sharedPageProps({ queryClient, context }),
  };
};

export default Login;